import type { FC, ReactElement } from "react";
import { useSelector } from "react-redux";
import { AdminDashboard, ManagerDashboard } from "../../components/Dashboards";
import { StoreInterfaces } from "../../types/store";

const Homepage: FC = (): ReactElement => {
  const session = useSelector((state: StoreInterfaces) => state.session);

  return (
    <>
      {session.isAdministrator && <AdminDashboard />}
      {session.isManager && <ManagerDashboard />}
    </>
  );
};

export default Homepage;
